import { Pane } from 'tweakpane';

export const pane = new Pane({
  title: 'Tweak Pane',
});
